module.exports = __webpack_public_path__ + "static/media/sl.2fa975f4.webp";